import { useMutation } from "@tanstack/react-query";
import { register } from "api/services/auth";
import Alert from "components/Alert";
import Button from "components/Button";
import InputField from "components/FormFields/InputField";
import React from "react";

export default function RegisterForm({ onRegister }) {
  const registerMutation = useMutation({
    mutationFn: register,
    onSuccess: onRegister,
  });
  const errorMessage = registerMutation.error?.response?.data?.error?.message;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        registerMutation.mutate({
          email: e.target.email.value,
          password: e.target.password.value,
          firstName: e.target.firstName.value,
          lastName: e.target.lastName.value,
        });
      }}
    >
      <div className="md:flex gap-2">
        <InputField
          required
          name="firstName"
          placeholder="Adınızı daxil edin"
          id="firstName"
          label="Adınız"
          className="flex-grow"
        />
        <InputField
          required
          name="lastName"
          placeholder="Soyadınızı daxil edin"
          id="lastName"
          label="Soyadınız"
          className="flex-grow"
        />
      </div>
      <InputField
        name="email"
        type="email"
        required
        placeholder="E-poçt ünvanınızı daxil edin"
        hint="E-poçt ünvanı hesabınızı təsdiqləmək üçün istifadə olunacaq"
        id="email"
        label="E-poçt ünvanınız"
      />
      <InputField
        name="password"
        placeholder="Şifrənizi daxil edin"
        id="password"
        label="Şifrəniz"
        type="password"
        minLength={6}
        onInput={(e) => {
          e.target.setCustomValidity("");
          if (!e.target.validity.valid) {
            e.target.setCustomValidity(
              "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
            );
          }
        }}
        onInvalid={(e) => {
          e.target.setCustomValidity("");
          if (!e.target.validity.valid) {
            e.target.setCustomValidity(
              "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
            );
          }
        }}
        required
      />

      <Button
        isLoading={registerMutation.isLoading}
        type="submit"
        className="mt-8 w-full fill-white"
      >
        Qeydiyyat
      </Button>

      {registerMutation.isError && <Alert type="error">{errorMessage}</Alert>}
    </form>
  );
}
